import { Application } from '../../gql/graphql';
import { getApplicationDetails } from '../../helpers/converters/getApplicationDetails';

// conisder the differences between undefined and 0. Tom thinks we should use undefined
const getApplicationId = (application?: Application) => {
  return getApplicationDetails(application)?.id ?? 0;
};

export default getApplicationId;
